import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useThemeHandlerPresenter } from './ThemeHandler.presenter';

export const ThemeHandler: FC = observer(() => {
  useThemeHandlerPresenter();

  return null;
});
